var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(Object.assign({}, _vm.getViewMode, {overflow: 'visible', fontSize: (_vm.getFontSize + "px !important"), zoom: ("" + _vm.getZoom)})),attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }